import { h } from 'preact';
import ShowtimesAppBase from 'base/showtimes/showtimesApp.js';
// import HubHeader from 'components/shared/hubHeader/hubHeader';


export default class ShowtimesApp extends ShowtimesAppBase {

	// getHeader = (client, appData, appState, activePage) => {
	// 	return <HubHeader activePage={activePage} roots={appData.urls.roots} headerData={appState.header} nav={appData.header.hubNav} pages={appData.pages} copy={appData.copy} />;
	// }
}
